<template>
  <div class="flex flex-col gap-7 w-full max-w-xl lg:max-w-none mx-auto">
    <SizeSelect />
    <PlanSelect v-if="store.ready" />
    <PlanSelectSkeleton v-else />
  </div>
</template>

<script setup lang="ts">
import { useBundleStore } from '@/stores'
import PlanSelect from '../bundle/plan-select.vue'
import SizeSelect from '../bundle/size-select.vue'
import PlanSelectSkeleton from '../bundle/plan-select-skeleton.vue'

const store = useBundleStore()
</script>
